import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { FIREBASE_CONFIG } from './endpoints'

const firebaseApp = initializeApp(FIREBASE_CONFIG)
const auth = getAuth(firebaseApp)

export { auth }
